/**
 * @file   carwash_website\Carwash-FrontEnd\src\Pages\CWOAppSettings.tsx
 * @brief  Add/CWO App settings.
 * @date   SEP, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Container, Button, Row, Col, Form, useOutletContext, useEffect, useState, useRef, Modal } from '../utils/thirdpartyComponents';
import CWRadio from '../components/CWRadio';
import Carwashlogo from '../assets/images/theme-logo.svg';
import PlusIcon from "../assets/images/plus-icon-grey.svg";
import CloseIcon from '../assets/images/icons/close';
import Browseimgicon from '../assets/images/browse-file.svg';
import SplashScreen from '../components/SplashScreen';
import HomeScreen from '../components/HomeScreen';
import SubscriptionsScreen from '../components/SubscriptionsScreen';
import AddIcon from '../assets/images/icons/addicon';
import { validateImageTypes } from '../utils/helper';
import { PRIMARY_COLOR, SECONDARY_COLOR, BUTTON_PRIMARY_COLOR, BUTTON_TEXT_COLOR, TEXT_PRIMARY_COLOR, CUSTOM_LOGO_IMAGE_SIZE } from '../utils/constants';
import { AppContextType } from '../interfaces/generalInterface';
import { MessageToaster } from "../utils/toastUtil";
import axios from '../config/axiosConfig';
import SmallLoader from '../components/SmallLoader';
import { CommonApi, AppsettingshApi } from "../utils/apiUrls";
import { CommonMessages } from "../messages/validationMessages"

const CWOAppSettings = () => {

    const [showConfirmpoup, setShowConfirmpoup] = useState<boolean>(false);
    //Hide ppopup
    const hideConfirmModal = () => {
        setShowConfirmpoup(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const showConfirmModal = () => {
        setShowConfirmpoup(true);
    }

    const [showResetpoup, setShowResetpoup] = useState<boolean>(false);
    //Hide ppopup
    const hideResetModal = () => {
        setShowResetpoup(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const showResetModal = () => {
        setShowResetpoup(true);
    }

    const [loading, setLoading] = useState(false);
    const toaster = new MessageToaster();
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [companyLogoUrl, setcompanyLogoUrl] = useState("");
    const [companysettingstypefromdb, setcompanysettingstypefromdb] = useState(0);
    const [companysettingstype, setcompanysettingstype] = useState(0);
    // Add formData state to AppSettings
    const [formData, setFormData] = useState({
        appTheme: {
            primary: '',
            secondary: '',
            btn_primary: '',
            btn_secondary: '',
            text_primary: ''
        },
        logoUrl: '',
        IsCustom: 1
    });

    const [defaultformData] = useState({
        appTheme: {
            primary: PRIMARY_COLOR,
            secondary: SECONDARY_COLOR,
            btn_primary: BUTTON_PRIMARY_COLOR,
            btn_secondary: BUTTON_TEXT_COLOR,
            text_primary: TEXT_PRIMARY_COLOR
        },
        logoUrl: '',
        IsCustom: 0
    });

    // Access the context
    const { updateData } = useOutletContext<AppContextType>();
    useEffect(() => {
        handleUpdate()
    }, [])

    // Update the data
    const handleUpdate = () => {
        updateData({ heading: "Custom Branding", url: "", showBackButton: false, showMainMenu: true, activeLink: "cwo-app-settings" });
    };

    const [companyLogo, setCompanyLogo] = useState("");
    const [companyLogoName, setcompanyLogoName] = useState("");
    const [logoImageError, setLogoImageError] = useState("");
    const [themeData, setThemeData] = useState({
        PrimaryColor: PRIMARY_COLOR,
        SecondaryColor: SECONDARY_COLOR,
        ButtonPrimaryColor: BUTTON_PRIMARY_COLOR,
        ButtonTextColor: BUTTON_TEXT_COLOR,
        TextPrimaryColor: TEXT_PRIMARY_COLOR
    });
    const [hasDefaultTheme, sethasDefaultTheme] = useState(true);
    const [showSave, setShowSave] = useState(true)

    const ColorChangeHandler = (e: any) => {
        e.target.parentElement.style.background = e.target.value;
        e.target.parentElement.children[0].style.display = "none";
        document.documentElement.style.setProperty('--' + e.target.name, e.target.value);
        setThemeData({
            ...themeData,
            [e.target.name]: e.target.value,
        });

    }

    //Upload Image
    const uploadCompanyLogo = async (e: any) => {
        setLogoImageError('');
        if (e.target.files && e.target.files[0]) {
            const img = e.target.files[0];
            const fileSizeMB = (img.size / 1048576).toFixed(2);
            if (parseFloat(fileSizeMB) > CUSTOM_LOGO_IMAGE_SIZE) {
                setLoading(false)
                setLogoImageError(CommonMessages.custom_logo_image_size_validation);
                return false;
            }
            const isValid = validateImageTypes(img);
            if (isValid) {
                const folderName = "logo/"
                const randomNumber = Math.floor(Math.random() * 1000000);
                const extension = img.name.substring(img.name.lastIndexOf("."));
                const newImageName = randomNumber + extension;
                setLoading(true)
                setCompanyLogo(URL.createObjectURL(img));
                setcompanyLogoName(img.name)
                const request_params = {
                    key: folderName + newImageName
                }

                const response = await axios.post(CommonApi.CARWASH_OWNER_PRESIGNED_URL, request_params)
                if (response?.data?.error === 0) {
                    const uploadURL = response.data.data
                    if (uploadURL) {
                        try {
                            // PUT request: upload file to S3
                            const result = await fetch(uploadURL, {
                                method: "PUT",
                                body: img,
                            });
                            if (result.status === 200) {
                                setLoading(false)
                                setFormData({
                                    ...formData,
                                    ['logoUrl']: folderName + newImageName,
                                    IsCustom: 1
                                });
                                setcompanyLogoUrl(folderName + newImageName);
                            } else {
                                setLoading(false)
                            }
                        } catch (e) {
                            setLoading(false)
                            console.log(e)
                        }
                    } else {
                        setLoading(false)
                    }
                } else {
                    setLoading(false)
                    setLogoImageError(response?.data?.message)
                }
            } else {
                setLogoImageError("Upload image files with .png or .jpeg extensions only.")
                setCompanyLogo('');
                setcompanyLogoName('')
            }
        }
    }

    const removeCompanyLogo = async () => {
        setcompanyLogoUrl('');
        setCompanyLogo('');
        setcompanyLogoName('');
        formData.logoUrl = "";
        // Reset the file input value to allow re-uploading the same file
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Setting to an empty string clears the input
        }
    }

    const resetCustomTheme = async () => {
        removeCompanyLogo();
        getAppSettings();
        setShowResetpoup(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const showCustomThemeScreen = async () => {
        setcompanysettingstype(1);
        sethasDefaultTheme(false);
    }

    const showDefaultThemeScreen = async () => {
        setcompanysettingstype(0);
        sethasDefaultTheme(true);
        // Show save button when switching to default theme
        setShowSave(true)
    }

    // To get app settings
    const getAppSettings = async () => {
        try {
            setLoading(true); // Show loader
            const { data } = await axios.get(AppsettingshApi.CARWASH_OWNER_GET_APP_SETTINGS);
            if (data.error === 0) {
                const resthemeData = data?.data?.appTheme ? JSON.parse(data.data.appTheme) : {};
                if (resthemeData && Object.keys(resthemeData).length > 0) {
                    setThemeData({
                        PrimaryColor: resthemeData.primary,
                        SecondaryColor: resthemeData.secondary,
                        ButtonPrimaryColor: resthemeData.btn_primary,
                        ButtonTextColor: resthemeData.btn_secondary,
                        TextPrimaryColor: resthemeData.text_primary
                    });
                    setFormData({
                        appTheme: {
                            primary: resthemeData.PrimaryColor,
                            secondary: resthemeData.SecondaryColor,
                            btn_primary: resthemeData.ButtonPrimaryColor,
                            btn_secondary: resthemeData.ButtonTextColor,
                            text_primary: themeData.TextPrimaryColor
                        },
                        logoUrl: data.data.logoFile,
                        IsCustom: data.data.IsCustom
                    });
                }
                else {
                    setThemeData({
                        PrimaryColor: PRIMARY_COLOR,
                        SecondaryColor: SECONDARY_COLOR,
                        ButtonPrimaryColor: BUTTON_PRIMARY_COLOR,
                        ButtonTextColor: BUTTON_TEXT_COLOR,
                        TextPrimaryColor: TEXT_PRIMARY_COLOR
                    })
                }
                const applogourl = data.data.logoFile;
                setcompanyLogoUrl(applogourl);
                setcompanysettingstype(data.data.IsCustom);
                setcompanysettingstypefromdb(data.data.IsCustom);
                if (data.data.IsCustom === 1) {
                    showCustomThemeScreen();
                }
            }
        } catch (error: any) {
            toaster.toastError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false); // Hide loader
        }
    }

    // Fetch app settings information on component mount
    useEffect(() => {
        getAppSettings();
        // Hide save button on initial load
        setShowSave(false)
    }, []);

    useEffect(() => {
        setFormData({
            appTheme: {
                primary: themeData.PrimaryColor,
                secondary: themeData.SecondaryColor,
                btn_primary: themeData.ButtonPrimaryColor,
                btn_secondary: themeData.ButtonTextColor,
                text_primary: themeData.TextPrimaryColor
            },
            logoUrl: companyLogoUrl,
            IsCustom: companysettingstype
        });
    }, [themeData, companyLogoUrl, companysettingstype]);

    const saveAppSettings = async () => {
        try {
            setLoading(true); // Show loader
            const responseaddAppSettings = (companysettingstype === 0) ?
                await axios.post(AppsettingshApi.CARWASH_OWNER_APP_SETTINGS_ADD, defaultformData) :
                await axios.post(AppsettingshApi.CARWASH_OWNER_APP_SETTINGS_ADD, formData);
            if (responseaddAppSettings?.data?.error === 0) {
                toaster.toastSuccess("Custom Branding added successfully.");
                setShowConfirmpoup(false);
                setcompanysettingstypefromdb(companysettingstype);
            }
            else {
                toaster.toastError(responseaddAppSettings?.data?.message);
            }

        } catch (error) {
            console.log(error)
            toaster.toastError('Failed to add Custom Branding.');
        } finally {
            setLoading(false); // Hide loader
        }
    }

    useEffect(() => {
        document.documentElement.style.setProperty('--PrimaryColor', themeData.PrimaryColor);
        document.documentElement.style.setProperty('--SecondaryColor', themeData.SecondaryColor);
        document.documentElement.style.setProperty('--ButtonPrimaryColor', themeData.ButtonPrimaryColor);
        document.documentElement.style.setProperty('--ButtonTextColor', themeData.ButtonTextColor);
        document.documentElement.style.setProperty('--TextPrimaryColor', themeData.TextPrimaryColor);
    }, [themeData]);


    return (
        <div className='hardware-listing-container cwo-appsettings-wrap'>
            <Container>
                <Button
                    title={(hasDefaultTheme) ? 'Add Custom Theme' : 'Switch to Default Theme'}
                    type="submit"
                    variant="primary"
                    className="primary-btn ms-auto mb-4 d-flex align-items-center"
                    // disabled={(!hasDefaultTheme) ? true : false}
                    onClick={(hasDefaultTheme) ? showCustomThemeScreen : showDefaultThemeScreen}
                >
                    {(hasDefaultTheme) ? 'Add Custom Theme' : 'Switch to Default Theme'}
                    <AddIcon />
                </Button>
                <div className="hardware-list-wrap">
                    <div className="form-inner mx-auto">
                        <div className="radio-field-group d-flex d-none">
                            <CWRadio
                                id="carwashtheme"
                                name="carwashtheme"
                                label="Car Wash Theme"
                            />
                            <CWRadio
                                id="carwashtheme"
                                name="carwashtheme"
                                label="Location Theme"
                            />
                        </div>
                        {hasDefaultTheme &&
                            <Row>
                                <Col md={6}>
                                    <div className="title-sec">
                                        <h5 className='f-bold'>Default Theme</h5>
                                    </div>
                                    <div className="theme-element-wrap">
                                        <p>Default Theme</p>
                                        <div className="color-palette d-flex align-items-center justify-content-center">
                                            <div className="color-box" style={{ background: PRIMARY_COLOR }}></div>
                                            <div className="color-box" style={{ background: SECONDARY_COLOR }}></div>
                                            <div className="color-box" style={{ background: BUTTON_PRIMARY_COLOR }}></div>
                                            <div className="color-box" style={{ background: BUTTON_TEXT_COLOR }}></div>
                                            <div className="color-box" style={{ background: TEXT_PRIMARY_COLOR }}></div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="title-sec">
                                        <h5 className='f-bold'>Default Logo</h5>
                                    </div>
                                    <div className="theme-element-wrap logo-block d-flex align-items-center justify-content-center">
                                        <img src={Carwashlogo} alt="Car Wash App" className='mx-auto' />
                                    </div>
                                </Col>
                            </Row>
                        }
                        {!hasDefaultTheme && <div className="app-customize-container">
                            <h5 className="f-bold">Pick a Color Scheme and Logo</h5>
                            <div className="customize-wrap d-grid">
                                <div className="color-logo-customizer">
                                    <div className="theme-element-wrap p-0 border-0">
                                        <p>Custom Theme</p>
                                        <div className="color-palette d-flex align-items-center justify-content-center">
                                            {/* <CWRadio
                                                    id="theme-select"
                                                    name="theme-select"
                                                    label="select"
                                                    checked={!hasDefaultTheme? true : false}
                                                    disabled
                                                /> */}
                                            <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: themeData.PrimaryColor }}>
                                                <img src={PlusIcon} alt="Car Wash App" />
                                                <Form.Control
                                                    type="color"
                                                    id="CWColorInput1"
                                                    name="PrimaryColor"
                                                    className="color-input position-absolute"
                                                    defaultValue={themeData.PrimaryColor}
                                                    title="Choose your color"
                                                    onChange={ColorChangeHandler}
                                                />
                                            </div>
                                            <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: themeData.SecondaryColor }}>
                                                <img src={PlusIcon} alt="Car Wash App" />
                                                <Form.Control
                                                    type="color"
                                                    id="CWColorInput2"
                                                    name="SecondaryColor"
                                                    className="color-input position-absolute"
                                                    defaultValue={themeData.SecondaryColor}
                                                    title="Choose your color"
                                                    onChange={ColorChangeHandler}
                                                />
                                            </div>
                                            <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: themeData.ButtonPrimaryColor }}>
                                                <img src={PlusIcon} alt="Car Wash App" />
                                                <Form.Control
                                                    type="color"
                                                    id="CWColorInput2"
                                                    name="ButtonPrimaryColor"
                                                    className="color-input position-absolute"
                                                    defaultValue={themeData.ButtonPrimaryColor}
                                                    title="Choose your color"
                                                    onChange={ColorChangeHandler}
                                                />
                                            </div>
                                            <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: themeData.ButtonTextColor }}>
                                                <img src={PlusIcon} alt="Car Wash App" />
                                                <Form.Control
                                                    type="color"
                                                    id="CWColorInput2"
                                                    name="ButtonTextColor"
                                                    className="color-input position-absolute"
                                                    defaultValue={themeData.ButtonTextColor}
                                                    title="Choose your color"
                                                    onChange={ColorChangeHandler}
                                                />
                                            </div>
                                            <div className="color-box d-flex align-items-center justify-content-center position-relative" style={{ background: themeData.TextPrimaryColor }}>
                                                <img src={PlusIcon} alt="Car Wash App" />
                                                <Form.Control
                                                    type="color"
                                                    id="CWColorInput2"
                                                    name="TextPrimaryColor"
                                                    className="color-input position-absolute"
                                                    defaultValue={themeData.TextPrimaryColor}
                                                    title="Choose your color"
                                                    onChange={ColorChangeHandler}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="logo-upload-sec">
                                        <div className="logo-customize d-flex">
                                            <div className="add-logo">
                                                <p>Add App Logo</p>
                                                <div className="common-cover d-flex align-items-center justify-content-center">
                                                    <div className="file-upload d-flex align-items-center justify-content-center">
                                                        <div className="upload-info text-center">
                                                            <img src={Browseimgicon} alt="" />
                                                            <p className='f-semi'>Browse for Logo Files</p>
                                                            {companyLogoName && <span className="file-name">{companyLogoName}</span>}
                                                        </div>
                                                        <Form.Control type="file" multiple className='file-input' onChange={uploadCompanyLogo} ref={fileInputRef} />
                                                    </div>
                                                </div>
                                                <p className='note mb-0 f-medium'>Preferred logo resolution is 150- 300 dpi with a transparent background. The file size must not exceed 2 MB.</p>
                                            </div>
                                            {companyLogo ? (
                                                <div className="preview-logo">
                                                    <p>Logo Preview</p>
                                                    <div className="common-cover d-flex align-items-center justify-content-center">
                                                        <Button variant="light" className="light-btn close" onClick={removeCompanyLogo}>
                                                            <CloseIcon />
                                                        </Button>
                                                        <img src={companyLogo} alt="Car Wash App" height="110px"/>
                                                    </div>
                                                </div>
                                            ) : (
                                                companyLogoUrl && (
                                                    <div className="preview-logo">
                                                        <p>Logo Preview</p>
                                                        <div className="common-cover d-flex align-items-center justify-content-center">
                                                            <Button variant="light" className="light-btn close" onClick={removeCompanyLogo}>
                                                                <CloseIcon />
                                                            </Button>
                                                            <img src={`${process.env.REACT_APP_S3_URL_PUBLIC_PATH}${companyLogoUrl}`} alt="Car Wash App" height="110px" />
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                            {logoImageError && (
                                                <span className="error-msg">{logoImageError}</span>
                                            )}
                                        </div>
                                        {/* <Button variant="primary" className="primary-btn f-medium" disabled>Preview</Button> */}
                                    </div>
                                </div>
                                <div className="app-preview">
                                    <p>App Preview</p>
                                    <div className="app-screens d-flex scroll-custom">
                                        {companyLogo ?
                                            <SplashScreen companyLogo={companyLogo} />
                                            :
                                            <SplashScreen companyLogo={companyLogoUrl ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH}${companyLogoUrl}` : companyLogo} />
                                        }
                                        <HomeScreen />
                                        <SubscriptionsScreen />
                                    </div>
                                </div>
                            </div>
                        </div>}
                        <div className="btn-sec d-flex justify-content-end">
                            {hasDefaultTheme && showSave &&
                                <Button
                                    title="Save"
                                    variant="primary"
                                    className="primary-btn"
                                    type="submit"
                                    onClick={companysettingstypefromdb === companysettingstype ? saveAppSettings : showConfirmModal}
                                >
                                    Save
                                </Button>
                            }
                            {!hasDefaultTheme &&
                                <>
                                    <Button title="Reset" variant="secondary" className="secondary-btn" onClick={showResetModal}>
                                        Reset
                                    </Button>
                                    <Button
                                        title="Save"
                                        variant="primary"
                                        className="primary-btn"
                                        type="submit"
                                        onClick={saveAppSettings}
                                    >
                                        Save
                                    </Button>
                                </>
                            }
                        </div>

                    </div>
                </div>
            </Container>
            {loading && <SmallLoader />}
            <Modal
                show={showConfirmpoup}
                onHide={hideConfirmModal}
                centered
                className='add-modal'
            >
                <Modal.Body className='text-center'>
                    <h5 className='f-bold text-center'>Are you sure, you want to switch to the default theme?</h5>
                    <div className="btn-sec d-grid">
                        <Button variant="light" className="secondary-btn" onClick={hideConfirmModal}>Not Now</Button>
                        <Button variant="primary" className='primary-btn btn-main m-0' onClick={saveAppSettings}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal
                show={showResetpoup}
                onHide={hideResetModal}
                centered
                className='add-modal'
            >
                <Modal.Body className='text-center'>
                    <h5 className='f-bold text-center'>Are you sure, you want to reset the theme?</h5>
                    <div className="btn-sec d-grid">
                        <Button variant="light" className="secondary-btn" onClick={hideResetModal}>Not Now</Button>
                        <Button variant="primary" className='primary-btn btn-main m-0' onClick={resetCustomTheme}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default CWOAppSettings;
